var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 58,
    viewBox: "0 0 60 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M27.7478 2.85938H27.5367C12.3286 2.85938 0 15.0195 0 30.0198V30.8354C0 45.8357 12.3286 57.9958 27.5367 57.9958H27.7478C42.9559 57.9958 55.2845 45.8357 55.2845 30.8354V30.0198C55.2845 15.0195 42.9559 2.85938 27.7478 2.85938Z",
    fill: "#001CA8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2257 4.2134L27.5014 38.281C27.0439 38.767 26.3929 39.062 25.7242 39.062C25.0732 39.062 24.4574 38.819 23.9999 38.3505L11.8064 26.1847C10.8562 25.2302 10.8562 23.6856 11.8064 22.7311C12.7565 21.7765 14.3225 21.7765 15.2726 22.7311L25.7418 33.1266L55.6539 0.898623C56.4984 -0.14267 58.0468 -0.298864 59.085 0.53417C60.1231 1.38456 60.299 2.91179 59.4369 3.95308C59.3665 4.03986 59.2961 4.12663 59.2081 4.19605L59.2257 4.2134Z",
    fill: "#001CA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.51159c1a001a246a97263c171f07052d.svg";
export { ForwardRef as ReactComponent };